// test1158
(1158 && 0);
